// import { YMaps, Map, Placemark, ZoomControl } from 'react-yandex-maps'
import React from 'react';
import { GoogleMap, Marker, useJsApiLoader } from '@react-google-maps/api';
import { StyledMap } from '@/components/styles';
import { useTranslation } from 'react-i18next';
import isMobile from '@/lib/isMobile';

const coords = {
  lat: 25.224808686925453,
  lng: 55.258225319838814,
};

const containerStyle = {
  height: '100%',
  width: '100%',
};

export default function ContactsMap({}) {
  const { i18n } = useTranslation('global');
  const { isLoaded } = useJsApiLoader({
    id: 'google-map-script',
    googleMapsApiKey: 'AIzaSyCsgljDdlF-kt8X57TvMBuvb93O_-MYp_E',
    language: i18n.language,
  });

  const [map, setMap] = React.useState(null);

  const onLoad = React.useCallback(function callback(map) {
    // This is just an example of getting and using the map instance!!! don't just blindly copy!
    const bounds = new window.google.maps.LatLngBounds(coords);
    map.fitBounds(bounds);

    setMap(map);
  }, []);

  const onUnmount = React.useCallback(function callback(map) {
    setMap(null);
  }, []);

  if (!isLoaded) return null;

  return (
    <StyledMap>
      <GoogleMap
        mapContainerStyle={containerStyle}
        defaultCenter={coords}
        center={coords}
        zoom={13}
        options={{ mapTypeControl: false }}
      >
        <Marker icon="/images/mapPin.png" position={coords} />
      </GoogleMap>
    </StyledMap>
  );
}
